// @flow
import React, { Component } from 'react'
import styleSheet from 'styled-components/lib/models/StyleSheet'

type Props = {
  html: string,
  head: Object,
  initialState: Object
}

class Root extends Component {
  props: Props

  renderInitialState() {
    if (this.props.initialState) {
      const initialState = `window.__INITIAL_STATE__ = ${JSON.stringify(
        this.props.initialState
      )}`
      return <script dangerouslySetInnerHTML={{ __html: initialState }} />
    }
    return false
  }

  render() {
    const { head, html } = this.props
    const styles = styleSheet
      .rules()
      .map((rule) => rule.cssText)
      .join('\n')

    return (
      <html lang="en">
        <head>
          {head.title.toComponent()}
          {head.meta.toComponent()}
          <link rel="stylesheet" href="/static/css/styles.css" />
          <link rel="shortcut icon" href="/static/images/favicon.png" />
          <style>{styles}</style>
        </head>
        <body>
          <div id="root" dangerouslySetInnerHTML={{ __html: html }} />
          {this.renderInitialState()}
          <script src="/static/js/bundle.js" />
          <script
            async
            defer
            src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBgiXh9dNomGlaJaRiKLDsdLwawwYE7EDY&libraries=places"
          />
          {head.script.toComponent()}
        </body>
      </html>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/containers/Root/index.js